import { Alert, Box, Button, CircularProgress, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDashboardContext } from 'src/context/hooks';
import { IEnvironment } from 'src/types/orgCredential';
import useFetcher, { endpoints } from 'src/utils/axios';

type Props = {
  environemt: IEnvironment | undefined;
};

export default function AlertComponent({ environemt }: Props) {
  const [message, setMessage] = useState<string>('');
  const { postData } = useFetcher();
  const { currentOrg } = useDashboardContext();

  useEffect(() => {
    if (environemt?.is_deploying) {
      setMessage(`deployment in progress for ${environemt?.name}`);
    } else if (environemt?.is_translating) {
      setMessage(`translation in progress for ${environemt?.name}`);
    } else if (environemt?.is_retrieving) {
      setMessage(`retrieve in progress for ${environemt?.name}`);
    } else {
      setMessage('');
    }
  }, [environemt]);

  const handleStopMetadataRetrieval = async () => {
    if (!environemt?.env_id) return;
    await postData(endpoints.metadata.stopRetrieve, {
      env_id: environemt?.env_id,
      org_id: currentOrg?.org_id,
    });
  };

  const handleStopMetadataDeployment = async () => {
    if (!environemt?.env_id || !currentOrg?.org_id) return;
    await postData(endpoints.metadata.stopDeploy, {
      env_id: environemt?.env_id,
      org_id: currentOrg?.org_id,
    });
  };
  const alertButton = () => (
    <>
      {environemt?.is_translating ? (
        <></>
      ) : (
        <Button
          variant="outlined"
          color="warning"
          onClick={
            environemt?.is_retrieving ? handleStopMetadataRetrieval : handleStopMetadataDeployment
          }
        >
          {environemt?.is_retrieving ? 'Cancel Retrieve' : 'Cancel Deployment'}
        </Button>
      )}
    </>
  );
  return (
    <>
      {message !== '' ? (
        <Box p={1} sx={{ maxWidth: '600px', marginRight: 'auto' }}>
          <Alert
            variant="outlined"
            severity="warning"
            icon={
              <Box sx={{ display: 'flex' }}>
                <CircularProgress color="inherit" size={20} />
              </Box>
            }
            sx={{ p: 2 }}
            action={alertButton()}
          >
            <Typography variant="body2" color="warning" sx={{ fontSize: '14px', fontWeight: 400 }}>
              {message}
            </Typography>
          </Alert>
        </Box>
      ) : (
        <></>
      )}
    </>
  );
}
